'use es6';

import http from './client';
const getHttpRequest = method => {
  switch (method) {
    default:
    case 'get':
      return http.get;
    case 'post':
      return http.post;
    case 'put':
      return http.put;
  }
};
const makeRequest = ({
  data,
  earlyRequestKey,
  method,
  query,
  url
}) => {
  const earlyRequest = earlyRequestKey && window.unsubscribeQuickFetch && window.unsubscribeQuickFetch.getRequestStateByName(earlyRequestKey);
  if (!earlyRequest) {
    const httpRequest = getHttpRequest(method);
    return httpRequest(url, {
      query,
      data
    });
  }
  return new Promise((resolve, reject) => {
    earlyRequest.whenFinished(result => {
      resolve(result);
      window.unsubscribeQuickFetch.removeEarlyRequest(earlyRequestKey);
    });
    earlyRequest.onError(() => {
      window.unsubscribeQuickFetch.removeEarlyRequest(earlyRequestKey);
      return makeRequest({
        data,
        method,
        query,
        url
      }).then(resolve, reject);
    });
  });
};
export default makeRequest;